export default __webpack_public_path__ + "static/media/IC00025-events_icon.890be27f.svg";